import { useEffect } from "react";
import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";

export default function About() {
  useEffect(() => {
    document.body.classList.remove("theme-mini");
  }, []);
  return (
    <div data-testid="about-page" className="bg-gs-cream min-h-screen">
      <MainHeader />
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-20 pb-16">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gs-ember">A note from the director</p>
        <h1 className="font-serif text-5xl md:text-6xl text-gs-ink mt-4 leading-[1.05]">
          I want every film I make to have a front door.
        </h1>
      </section>
      <section className="max-w-3xl mx-auto px-6 md:px-12 pb-24 font-serif text-xl text-gs-ink/85 leading-[1.7] space-y-7">
        <p>
          Cinema used to arrive somewhere. A poster outside, an usher in the lobby, a single screen lit only by the film you came to see. The internet never gave indie filmmakers that. We got tiles. We got recommendations. We got placed between commercials.
        </p>
        <p>
          <span className="font-display text-3xl text-gs-ember">Green Screen</span> is my answer. It is a single-screen cinema online where every film I release gets its own theatrical home — a mini-site that exists for one purpose: to show you that movie the way it deserves to be shown.
        </p>
        <p>
          We screen one or two titles at a time. No back-catalog overload. No autoplay tile graveyard. When a film opens here, it opens the way it would in a real theater: with a marquee, a trailer, a synopsis card, and a ticket booth. You rent it, you buy it, you watch.
        </p>
        <p className="font-sans text-base text-gs-ink/60 italic mt-12">
          — Mira Aleson, founder
        </p>
      </section>
      <MainFooter />
    </div>
  );
}
